import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { TableHead } from "~/pages/inventory/components/TableHead";
import { Header } from "~/types/table";

import { TicketsTitleCell } from "~/pages/tickets/tickets/TicketsTable/TicketsTitleCell";
import { ListCaseEdges } from "~/pages/tickets/types";
import { TicketsCloseButtonCell } from "~/pages/tickets/tickets/TicketsTable/TicketsCloseButtonCell";
import { Link } from "react-router-dom";
import { TicketsClosedCell } from "~/pages/tickets/tickets/TicketsTable/TicketsClosedCell";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";
import { Paginate, PaginateProps } from "~/components/pagination/paginate";
import toPercentage from "~/lib/toPercentage";

type VulnerabilitiesTableProps = {
  tickets: ListCaseEdges | null | undefined;
  isLoading: boolean;
  onClose?: (mrn: string) => void;
  isOpen?: boolean;
  scope: SpaceOrWorkspaceScope;
  paginateProps?: PaginateProps;
};

export const TicketsTable = ({
  tickets,
  isLoading,
  onClose,
  isOpen = false,
  scope,
  paginateProps,
}: VulnerabilitiesTableProps) => {
  const tableHeaders: Header[] = [
    {
      id: "EMPTY_CELL",
      label: " ",
      options: {
        width: "16px",
      },
      sortable: false,
    },
    {
      id: "TICKET",
      label: "Ticket",
      sortable: false,
    },
    {
      id: "CLOSE_TICKET",
      label: " ",
      sortable: false,
    },
  ];

  const ticketsRows =
    tickets?.flatMap((t) => (t.__typename === "CaseEdge" ? t.node : [])) || [];

  return (
    <Paper sx={{ my: 3 }}>
      <TableContainer>
        <Table>
          <TableHead tableHeaders={tableHeaders} />
          <TableBody>
            {ticketsRows.map((c) => {
              const percentage = Math.floor(
                toPercentage(c.closedRefsCount, c.totalRefsCount),
              );
              return (
                <TableRow
                  key={c.mrn}
                  component={Link}
                  to={`/space/ticket?${scope.params}&caseMrn=${c.mrn}`}
                  sx={{
                    "&.MuiTableRow-root:hover .firewatch-chip": {
                      backgroundColor: "background.lighter",
                    },
                    "&:hover .closeCase": {
                      display: "flex",
                    },
                    "&:hover .progressBar": {
                      display: "none",
                    },
                  }}
                  data-testid={`${isOpen ? "open" : "closed"}-ticket-table-row`}
                >
                  <TableCell></TableCell>
                  <TicketsTitleCell
                    key={c.mrn}
                    isOpen
                    title={c.title}
                    assets={c.assetsCount}
                    createdAt={c.createdAt}
                    tags={c.tags || []}
                  />
                  {isOpen ? (
                    <TicketsCloseButtonCell
                      percentage={percentage}
                      isLoading={isLoading}
                      isOpen={isOpen}
                      onClick={async (e) => {
                        e.preventDefault();
                        onClose?.(c.mrn);
                      }}
                    />
                  ) : (
                    <TicketsClosedCell />
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {paginateProps && <Paginate {...paginateProps} />}
    </Paper>
  );
};
